import { render } from "./NavigationMore.vue?vue&type=template&id=31291b88&ts=true"
import script from "./NavigationMore.vue?vue&type=script&lang=ts"
export * from "./NavigationMore.vue?vue&type=script&lang=ts"

import "./navigation-link.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__